import {
  CREATE_ADMIN_ACCOUNT_REQUEST,
  CREATE_ADMIN_ACCOUNT_SUCCESS,
  CREATE_ADMIN_ACCOUNT_FAILURE,
} from '../../../../Constants/actionTypes';

import { createAdminAccountApi } from '../../../../Constants/apiService';

export const createAdminAccountRequest = () => ({ type: CREATE_ADMIN_ACCOUNT_REQUEST });
export const createAdminAccountSuccess = () => ({ type: CREATE_ADMIN_ACCOUNT_SUCCESS });
export const createAdminAccountFailure = (error) => ({
  type: CREATE_ADMIN_ACCOUNT_FAILURE,
  payload: error,
});

export const createAdminAccountAct = (payload) => {
  return async (dispatch, getState) => {
    dispatch(createAdminAccountRequest());

    const accessToken = getState()?.auth?.accessToken;

    try {
      const data = await createAdminAccountApi(payload, accessToken);
      dispatch(createAdminAccountSuccess());
      return data;
    } catch (error) {
      const errorMessage =
        error?.message === 'Failed to fetch' || error?.message?.includes('NetworkError')
          ? 'Server is currently down. Please try again later.'
          : error?.message || 'Unable to create the account. Please try again.';

      dispatch(createAdminAccountFailure(errorMessage));
      throw new Error(errorMessage);
    }
  };
};
